import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    payAllAtOnceSuccess,
    payAllAtOnceFail,
    payAllAtOnce,
} from './dossier.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';

@Injectable()
export class DossiersRecordEffects {

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'dossier-details?id='+data.id+"&signature="+data.signature;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        const data = response.data;
                        return fetchSingleRecordSuccess({singleData: data});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    payAllAtOnce$ = createEffect(() =>
        this.actions$.pipe(
            ofType(payAllAtOnce),
            exhaustMap((data: any) => {
                const url = data.url;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {

                        if(response.data.completed == true){
                            this.routeService.triggerRoute(null, "/payment/completed");
                        }else if(response.data.url){
                            window.location.assign(response.data.url);
                        }

                        return payAllAtOnceSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => payAllAtOnceFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>
    ) { }

}